/**
 * @desc 配置参数
 *
 * @copyright 是否显示天桃公司名称和logo等信息
 */

'use strict'

const host = ''

export default {
  host,
  service: {
    url: '/api',
    method: 'post',
    baseURL: host,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: 60000,
    responseType: 'json'
  },
  NoCopyright: false,
  storage: {
    authTokenKey: 'TG_SERVER_TOKEN',
    authInfoCacheKey: 'TG_SERVER_AUTH_INFO_CACHE',
    patientKey: 'TG_SERVER_PATIENT',
    signatureKey: 'TG_SERVER_SIGNATURE'
  },
  pageSize: 15,
  sexMap: ['未知', '男', '女'],
  ageMap: ['岁', '月', '天'],
  uploadUrl: host + '/common/perform_upload_file',
  // 上传文件返回file_to_base64格式
  uploadUrlBase64: host + '/common/file_to_base64',
  uploadUrlFils: host + '/common/admin_upload_file',
  uploadUrlMedicineFils: host + '/common/medicine_list_upload'
}



// WEBPACK FOOTER //
// ./src/config.js